import { Button, Paper, Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import type { ReactElement } from 'react';

interface Props {
  message: string;
  onRetry?: () => void;
}

const MattersListErrorState = ({ message, onRetry }: Props): ReactElement => (
  <StyledPaper variant="outlined">
    <ContentStack direction="column" alignItems="center">
      <StyledErrorIcon aria-hidden />
      <MessageText variant="body1">{message}</MessageText>
      {onRetry && (
        <Button
          variant="outlined"
          onClick={onRetry}
          aria-label="Retry loading matters"
        >
          Try again
        </Button>
      )}
    </ContentStack>
  </StyledPaper>
);

export { MattersListErrorState };

const StyledPaper = styled(Paper)(({ theme }: { theme: Theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
  borderColor: theme.palette.divider,
}));

const ContentStack = styled(Stack)(({ theme }: { theme: Theme }) => ({
  gap: theme.spacing(2),
}));

const StyledErrorIcon = styled(ErrorOutline)(({ theme }: { theme: Theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  color: theme.palette.error.main,
}));

const MessageText = styled(Typography)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.text.secondary,
}));
